import * as React from 'react';

type Props = {
  width?: number;
  height?: number;
  className?: string;
};

const SFCPlayIconSvg = ({ width = 20, height = 20, className }: Props) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="10" cy="10" r="9.25" stroke="white" strokeWidth="1.5" />
      <path d="M7.69232 13.8462L13.5385 10.4L7.69232 6.46155V13.8462Z" fill="white" />
    </svg>
  );
};

export default SFCPlayIconSvg;
